import { FireOutbreakReactionEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { CantRelateFireOutbreakOptionStrategy } from '../strategies/CantRelateFireOutbreakOption.strategy'
import { FireOutbreakReaction } from '../strategies/FireOutbreakReaction.abstract'
import { NotOccurredFireOutbreakOptionStrategy } from '../strategies/NotOccurredFireOutbreakOption.strategy'
import { OccurredFireOutbreakOptionStrategy } from '../strategies/OccurredFireOutbreakOption.strategy'

export class FireOutbreakReactionOptionsFactory {
	static make(reaction?: FireOutbreakReactionEnum): FireOutbreakReaction[] {
		if (!reaction) {
			return [
				new OccurredFireOutbreakOptionStrategy(),
				new NotOccurredFireOutbreakOptionStrategy(),
				new CantRelateFireOutbreakOptionStrategy(),
			]
		}

		switch (reaction) {
			case FireOutbreakReactionEnum.POSITIVE:
				return [
					new NotOccurredFireOutbreakOptionStrategy(),
					new CantRelateFireOutbreakOptionStrategy(),
				]
			case FireOutbreakReactionEnum.NEGATIVE:
				return [
					new OccurredFireOutbreakOptionStrategy(),
					new CantRelateFireOutbreakOptionStrategy(),
				]
			default:
				return [
					new OccurredFireOutbreakOptionStrategy(),
					new NotOccurredFireOutbreakOptionStrategy(),
				]
		}
	}
}
